
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookings/calendar",
      function () {
        return require("private-next-pages/bookings/calendar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookings/calendar"])
      });
    }
  